<template>
  <section>
    <p class="gp-section-title">
      <span>{{ position }}</span
      >Abmessungen
    </p>

    <div class="g-pb-10" v-if="description">
      <p class="gea-two-column-description">
        {{ description }}
      </p>
    </div>

    <div class="gp-2-column">
      <div class="gp-left-column">
        <div class="g-flex g-flex-col g-w-full g-mt-2 g-mb-4">
          <div class="g-flex g-justify-between">
            <label for="breite" class="g-text-lg g-font-bold"
              >Breite <span class="g-font-normal g-text-sm g-text-grey-700">(Kante A oder C)</span></label
            >
            <p class="g-text-grey-600">in Metern</p>
          </div>
          <input
            type="text"
            name="Breite"
            id="breite"
            class="g-border g-rounded g-border-gray-300 g-p-2 mg-b-1"
            :value="width"
            @input="updateWidth"
            @focus="activeSide = 'horizontal'"
            @blur="handleBlur"
            placeholder="5.42"
          />
        </div>

        <div class="g-flex g-flex-col g-w-full g-mt-2 g-mb-4">
          <div class="g-flex g-justify-between">
            <label for="tiefe" class="g-text-lg g-font-bold"
              >Tiefe <span class="g-font-normal g-text-sm g-text-grey-700">(Kante B oder D)</span></label
            >
            <p class="g-text-grey-600">in Metern</p>
          </div>
          <input
            type="text"
            name="Tiefe"
            id="tiefe"
            class="g-border g-rounded g-border-gray-300 g-p-2 mg-b-1"
            :value="depth"
            @input="updateDepth"
            @focus="activeSide = 'vertical'"
            @blur="handleBlur"
            placeholder="8.50"
            notab="notab"
          />
        </div>
      </div>

      <div class="gp-right-column">
        <roof-image :active="activeSide"></roof-image>
      </div>
    </div>
  </section>
</template>

<script>
import RoofImage from "../components/RoofImage.vue";
export default {
  components: { RoofImage },
  name: "Abmessungen",

  created() {
    // For testing with fixed values
    // setTimeout(() => {
    //   this.updateValues("width", "6,02");
    //   this.updateValues("depth", "7,4");
    // }, 600);
  },

  data() {
    return {
      activeSide: "",
      timeout: null,
    };
  },

  computed: {
    width() {
      return this.$store.state.abmessungen.width;
    },

    depth() {
      return this.$store.state.abmessungen.depth;
    },
  },

  methods: {
    updateWidth(e) {
      this.handleInput("width", e.target.value);
    },

    updateDepth(e) {
      this.handleInput("depth", e.target.value);
    },

    handleBlur() {
      this.activeSide = "";
    },

    handleInput(side, value) {
      // Debounce input
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.updateValues(side, value);
      }, 1000);
    },

    updateValues(side, value) {
      if (side === "width") {
        let cleanValue = parseFloat(value.replace(",", ".")) || 0;
        this.$store.commit("abmessungen/setWidth", cleanValue.toFixed(2) + "");
      } else if (side === "depth") {
        let cleanValue = parseFloat(value.replace(",", ".")) || 0;
        this.$store.commit("abmessungen/setDepth", cleanValue.toFixed(2) + "");
      }
    },
  },

  props: ["position", "description"],
};
</script>

<style></style>
